import React, { useState } from 'react';
import './MoreInfoProducts.css';

const MoreInfoProducts = ({ moreinfo }) => {
  const [expanded, setExpanded] = useState(false);

  if (!moreinfo) return null;

  const wordLimit = 50;
  const words = moreinfo.split(' ');
  const isLong = words.length > wordLimit;

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="moreinfo-container">
      <h3 className="moreinfo-title">פרטים נוספים</h3>
      <div className="moreinfo-box">
        <p>
          {expanded || !isLong
            ? moreinfo
            : words.slice(0, wordLimit).join(' ') + '...'}
        </p>
        {isLong && (
          <button className="toggle-moreinfo-btn" onClick={toggleExpanded}>
            {expanded ? 'הצג פחות' : 'הצג עוד'}
          </button>
        )}
      </div>
    </div>
  );
};

export default MoreInfoProducts;
